import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// 引用UI框架
import "bootstrap";
// import "bootstrap/dist/css/bootstrap.css";
import i18n from "./i18n/i18n";
// api
import api from "../../admin/src/api";
// 全局变量
Vue.prototype.$baseUrl = process.env.BASE_URL;
console.log(process.env.BASE_URL)
Vue.prototype.$api = api;

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  ];
  var flag = false;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true;
      break;
    }
  }
  return flag;
}
Vue.prototype.$isMobile = IsPC();

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
